export default __webpack_public_path__ + "static/media/Amper_photo_07.756808e4.jpg";